module.exports = __webpack_public_path__ + "static/assets/0c99f9ea906ff38c8d007ab9f7607bc6.png";